import { AppSolicitudes } from '../../../core/models/appSolicitides.model';
import { AppSolicitudesService } from '../../../core/services/appSolicitudes.service';
import { UserService } from '../../../core/services/user.service';

import { HttpParams } from '@angular/common/http';
import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, EventEmitter, OnInit, Output, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { MatDialog } from '@angular/material/dialog';
import { AcceptRejectDialogComponent } from '../../accept-reject-dialog/accept-reject-dialog.component';
import { Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CalendarioComponent } from '../../calendario/calendario.component';

import XLSX from "xlsx-js-style"
import { LivesSessionHelper } from '../../../core/helper/livesSessionHelper';

@Component({
  selector: 'app-solicitudes-list',
  templateUrl: './solicitudes-list.component.html',
  styleUrls: ['./solicitudes-list.component.scss'],
  providers: [AppSolicitudesService, UserService]
})
export class SolicitudesListComponent extends ListFormBase<AppSolicitudes> implements AfterViewInit {
  // Propiedades del panel contenedor
  panelIcon = 'event_available'; // Material icon
  panelTitle = 'Solicitudes';
  panelDescription = 'Listado de las solcitudes ';

  gridComponent: any;
  allData: any;
  selectedRows = [];
  selectableRowsId: any[] = [];
  selectableRowsIndex: any[] = [];
  disabledRows: any[] = [];
  displayHolidayBag: boolean = false;


  solicitudBolsaState: number;
  solicitudBolsaStateName: string;

  disableManageButton = false;
  exporting = false;

  constructor(
    protected _modelService: AppSolicitudesService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _acceptRejectPopUp: MatDialog,
    private renderer: Renderer2,
    private usersInorcaService: UserService,
    @Inject(DOCUMENT) private document: Document,
    private _livesSession: LivesSessionHelper,
  ) {
    super(_modelService, _router, _route, _messageDialog, AppSolicitudes);
    this.isCrud = true;
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getDataSource();

    });
  }


  async onEditorPreparing(e) {
    //Obtener todos los datos
    const allData = e.component.getDataSource().items();
    const userLogged = this._livesSession.AspNetUserId; //ID del usuario logeado

    this.selectableRowsId = [];
    this.selectableRowsIndex = [];

    // Usar un bucle for...of para manejar la asincronía
    for (const [index, row] of allData.entries()) {

      /* row.validatorHr = await this.getHrValidatorData(row.validatorHr); */ /* Ya no es necesario validar que el usuario sea de rrhh porque tiene que serlo para entrar en LivesHR */

      if (/* row.validatorHr.Id === userLogged  &&*/ row.stateHr.requestState1 == '0' && (row.state.requestState1 == '1' || row.state.requestState1 == '0') && !this.selectableRowsId.includes(row.request1)) {
        this.selectableRowsId.push(row.request1);
        this.selectableRowsIndex.push(index);
      }

      if (row.company.holidayBagAllowed) {
        this.displayHolidayBag = true;
      }

    }
    if (e.parentType === 'dataRow') {
      // Obtengo el id de la fila que se comprueba
      const currentRowId = e.row.data.request1;
      // Deshabilita la casilla de selección si no es seleccionable
      if (!this.selectableRowsId.includes(currentRowId)) {
        e.editorOptions.disabled = true;
      }
    }
  }

  updateSelectedRows(e) {
    this.gridComponent = e.component;
    const selectedRowsDataArr = [];
    let hasDisabledRow = false;
  
    e.selectedRowsData.forEach(row => {
      const selectedRowKeys = e.component.getSelectedRowKeys();
      const rowIndex = selectedRowKeys.findIndex(rowKey => 
        rowKey.request1 === row.request1 && this.selectableRowsId.includes(rowKey.request1)
      );
  
      if (selectedRowKeys[rowIndex]) {
        selectedRowsDataArr.push(selectedRowKeys[rowIndex]);
  
        // Si alguna solicitud no es editable, marcar el botón como deshabilitado
        if (!this.canEditRequest(row)) {
          hasDisabledRow = true;
        }
      }
    });
  
    if (selectedRowsDataArr.length < 1) {
      e.component.deselectAll();
    }
  
    this.selectedRows = selectedRowsDataArr;
    this.disableManageButton = hasDisabledRow; // Actualiza el estado del botón
  }
  

  orderHRStateName(HRStateName: string) {
    switch (HRStateName) {
      case 'Pendiente':
        return 1;
      case 'Aprobado':
        return 2;
      case 'Rechazado':
        return 3;
      case 'No admitida':
        return 4;
    }
  }

  deselectAllRows() {
    if (this.gridComponent) {
      this.gridComponent.deselectAll();
    }
  }

  onOpenCalendar() {
    const dialogRef = this._acceptRejectPopUp.open(CalendarioComponent, {
      width: '100%',
      data: { appointments: this.dataSource }
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[0];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
      this.renderer.setStyle(dialogContainer, 'max-height', '90vh'); // Limita la altura del popup
      this.renderer.setStyle(dialogContainer, 'overflow-y', 'auto'); // Habilita scroll vertical
      this.renderer.addClass(dialogContainer, 'scrollable-section');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.selectedRows = [];
      this.deselectAllRows();
      this.getDataSource();
    });
  }


  onClickManage() {
    const dialogRef = this._acceptRejectPopUp.open(AcceptRejectDialogComponent, {
      width: '90%',
      data: {
        data: this.selectedRows,
        calendarData: this.dataSource
      }
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {

      this.selectedRows = [];
      this.deselectAllRows();
      this.getDataSource();
    });
  }

  getDuration(data: any): string {

    if (data.associatedPersonalRequest) {
      return '----'
    } else if (data.lessThanOneDay) {
      return data.duration
    } else {
      const startDate: any = new Date(data.startDate);
      const endDate: any = new Date(data.endDate);
      const daysDifference = (endDate - startDate) / (1000 * 60 * 60 * 24);
      const realDays = daysDifference + 1;
      const daysText = realDays === 1 ? "día" : "días";


      return `${realDays} ${daysText}`
    }
  }


  async getHrValidatorData(id: any): Promise<any> {
    try {
      const response = await this.usersInorcaService.getModel(id).toPromise();
      return response;
    } catch (error) {
      // console.error(error);
    }
  }


  onCellPrepared(e) {
    if (e.rowType === 'data') {
      // Verificar si la columna es una fecha
      if (['startDate', 'endDate', 'createdAt'].includes(e.column.dataField)) {
        const dateValue = new Date(e.value);

        if (!e.value || dateValue.getFullYear() === 1 || dateValue.getFullYear() === 0o1) {
          e.cellElement.innerText = '---';
        } else {
          e.cellElement.innerText = dateValue.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          });
        }
      }

      const currentRowId = e.data.request1;

      // Verifica si el cellElement contiene las clases necesarias
      const hasClasses = e.cellElement.classList.contains('dx-command-select') &&
        e.cellElement.classList.contains('dx-editor-cell') &&
        e.cellElement.classList.contains('dx-editor-inline-block');


      //Deshabilito el boton si ya está validada y no tiene bolsa o la tiene validada también

      const matchingItem = this.dataSource.find(item => item.request1 === currentRowId);
      const matchingItemHolidayBagState = matchingItem.associatedHolidayBag?.state.requestState1;
      if (matchingItem.stateHr.requestState1 !== '0' && hasClasses && matchingItemHolidayBagState !== '0' && matchingItemHolidayBagState !== undefined) {

        // Deshabilita eventos de puntero
        e.cellElement.style.pointerEvents = 'none';


        // Cambiar el color para que visualmente se vea deshabilitado 
        const spanElement = e.cellElement.querySelector('div > div > span');
        if (spanElement) {
          spanElement.style.borderColor = 'silver';
        }

      }


      /* 
      //Deshabilito el boton si ya está validada y no tiene bolsa o la tiene validada también
      
            const matchingItem = this.dataSource.find(item => item.request1 === currentRowId);
            /* 
                  if (matchingItem.stateHr.requestState1 !== '0' && hasClasses && matchingItem.associatedHolidayBag?.state.requestState1 !== '0') {
                    // Deshabilita eventos de puntero
                    e.cellElement.style.pointerEvents = 'none';
            
                    // Cambiar el color para que visualmente se vea deshabilitado 
                    const spanElement = e.cellElement.querySelector('div > div > span');
                    if (spanElement) {
                      spanElement.style.borderColor = 'silver';
                    } 
                  }*/
    }

    if (e.rowType === 'data' && (e.column.dataField === 'state.name' || e.column.dataField === 'stateHr.name' || e.column.dataField === 'associatedHolidayBag.state.name')) {
      const stateName =
        e.column.dataField === 'state.name'
          ? e.data.state.name
          : e.column.dataField === 'stateHr.name'
            ? e.data.stateHr.name
            : e.column.dataField === 'associatedHolidayBag.state.name'
              ? e.data.associatedHolidayBag ? e.data.associatedHolidayBag.state.name : 'No solicitada'
              : null;

      const containerElement = document.createElement('div');
      const textElement = document.createElement('span');
      const iconElement = document.createElement('i');

      // Configura el contenedor para usar flexbox
      containerElement.style.display = 'flex';
      containerElement.style.width = '2.5em';
      containerElement.style.height = '2.5em';
      containerElement.style.alignItems = 'center';
      containerElement.style.justifyContent = 'center';
      containerElement.style.borderRadius = '20px';
      containerElement.style.color = 'white';
      containerElement.style.margin = 'auto';

      // Configura el elemento de texto
      textElement.textContent = stateName;

      if (stateName === 'Aprobado') {
        containerElement.style.backgroundColor = '#4caf50';
        iconElement.className = 'fas fa-check status-icon';
      } else if (stateName === 'Rechazado') {
        containerElement.style.backgroundColor = '#f44336';
        iconElement.className = 'fas fa-times status-icon';
      } else if (stateName === 'Pendiente') {
        containerElement.style.backgroundColor = 'orange';
        iconElement.className = 'fas fa-hourglass-half status-icon';
      } else if (stateName === 'No solicitada' || stateName === 'No admitida') {
        containerElement.style.backgroundColor = 'silver';
        iconElement.className = 'fas fa-ban status-icon';
      }

      // Limpia el contenido de la celda y añade el contenedor
      e.cellElement.innerHTML = '';
      containerElement.appendChild(iconElement);
      e.cellElement.appendChild(containerElement);


      e.cellElement.onmouseenter = (event) => {
        const tooltip = document.createElement('div');
        tooltip.textContent = textElement.textContent;
        tooltip.style.position = 'absolute';
        tooltip.style.backgroundColor = '#007ac3';
        tooltip.style.color = '#fff';
        tooltip.style.padding = '5px 5px';
        tooltip.style.borderRadius = '4px';
        tooltip.style.whiteSpace = 'nowrap';
        tooltip.style.zIndex = '1000';
        tooltip.style.fontSize = '12px';

        document.body.appendChild(tooltip);

        const updateTooltipPosition = (e) => {
          tooltip.style.left = `${e.pageX + 10}px`;
          tooltip.style.top = `${e.pageY + 10}px`;
        };

        updateTooltipPosition(event);

        e.cellElement.onmousemove = updateTooltipPosition;

        e.cellElement.onmouseleave = () => {
          document.body.removeChild(tooltip);
        };
      };
    }

    if (e.rowType === 'data' && e.column.dataField == 'type') {
      var requestTypeText = [];

      // Check and append 'Email' if available
      if (e.data?.associatedPersonalRequest?.email) {
        requestTypeText.push('Email');
      }

      // Check and append 'Banco' if available
      if (e.data?.associatedPersonalRequest?.bankAccount) {
        requestTypeText.push('Banco');
      }

      if (e.data?.associatedPersonalRequest?.acronym || e.data?.associatedPersonalRequest?.streetName || e.data?.associatedPersonalRequest?.buildingNumber || e.data?.associatedPersonalRequest?.stairwell || e.data?.associatedPersonalRequest?.floor || e.data?.associatedPersonalRequest?.gate || e.data?.associatedPersonalRequest?.postalCode || e.data?.associatedPersonalRequest?.countryId) {
        requestTypeText.push('Dirección');
      }


      // Join all request types with commas and format the cell text
      e.cellElement.innerText = `${e.value} ${requestTypeText.length > 0 ? `(${requestTypeText.join(', ')})` : ''}`;
    }

  }



  selectRowToEdit(key: any) {
    this.selectedRows = [key];
    this.onClickManage()
  }


  onExporting(e) {
    e.cancel = true;

    // Obtener los datos filtrados aplicando los filtros actuales
    e.component.getDataSource().store().load({ filter: e.component.getCombinedFilter() }).then(filteredData => {
      const dataToExport = filteredData.map(row => {
        const rowData: any = {
          Estado: row.state?.name || '---',
          RRHH: row.stateHr?.name || '---',
          Empresa: row.company?.name || '---',
          Nombre: row.user?.fullName || '---',
          Tipo: row.type || '---',
          Inicio: this.formatExportDate(row.startDate),
          Fin: this.formatExportDate(row.endDate),
          'Fecha Solicitud': this.formatExportDate(row.createdAt),
        };

        if (this.displayHolidayBag) {
          rowData['Bolsa'] = row.associatedHolidayBag?.state?.name || 'No solicitada';
        }

        return rowData;
      });

      this.exportToExcel(dataToExport, 'Listado_Solicitudes_LivesHR');
    });
  }

  formatExportDate(date: any): string {
    if (!date) return '---';
    const parsedDate = new Date(date);
    return parsedDate.getFullYear() <= 1 ? '---' : parsedDate.toLocaleDateString('es-ES');
  }

  exportToExcel(data: any[], fileName: string): void {
    const worksheet = XLSX.utils.json_to_sheet(data, {
      header: Object.keys(data[0] || {}),
      skipHeader: false
    });

    const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
    for (let row = headerRange.s.r; row <= headerRange.e.r; row++) {
      for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = {
          font: { bold: row === 0, color: { rgb: "000000" } },
          alignment: { horizontal: "center" },
          border: row === 0 ? { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } : {}
        };
      }
    }

    const colWidths = Object.keys(data[0] || {}).map((key) => ({
      wch: Math.max(...data.map(row => (row[key] ? row[key].toString().length : 0)), key.length) + 2
    }));
    worksheet['!cols'] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Solicitudes");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }

  canEditRequest(appointment: any): boolean {
    const userLogged = this._livesSession.AspNetUserId;

    const enabledHolidayBagValidator = appointment.associatedHolidayBag?.holidayBagValidatorData?.hostelUserId === userLogged;
    const enabledValidator = appointment.hrValidators?.some((validator: any) => validator.hostelUserId === userLogged);
    const advanceValidator = appointment.associatedAdvanceRequest?.validatedByData?.hostelUserId === userLogged;

    return enabledHolidayBagValidator || enabledValidator || advanceValidator;
  }


}
